import { Mail, MessageCircle, MapPin } from 'lucide-react';
import { BRAND, waLink } from '../lib/constants';
import { SkipSearchForm } from '../components/SkipSearchForm';

export default function Contact() {
  return (
    <div data-testid="contact-page" className="bg-white">
      <section className="pt-32 pb-16 container-edge">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#eb5381]">Contact</div>
        <h1 className="mt-3 font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight max-w-3xl">
          Let's <span className="italic text-[#a465a8]">talk</span> beauty.
        </h1>
      </section>

      <section className="container-edge grid md:grid-cols-3 gap-px bg-[#eaeaea] mb-20">
        <a href={waLink('Hi FindYourMUA!')} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="bg-white p-10 hover:bg-[#fff8ee] transition-colors">
          <MessageCircle className="w-6 h-6 text-[#eb5381]" />
          <div className="mt-5 text-[10px] uppercase tracking-[0.3em] text-neutral-500">WhatsApp</div>
          <div className="mt-2 font-serif text-2xl">{BRAND.whatsapp}</div>
          <div className="mt-2 text-sm text-neutral-600">Fastest replies. 9 AM – 9 PM IST.</div>
        </a>
        <a href={`mailto:${BRAND.email}`} data-testid="contact-email" className="bg-white p-10 hover:bg-[#fff8ee] transition-colors">
          <Mail className="w-6 h-6 text-[#eb5381]" />
          <div className="mt-5 text-[10px] uppercase tracking-[0.3em] text-neutral-500">Email</div>
          <div className="mt-2 font-serif text-2xl break-all">{BRAND.email}</div>
          <div className="mt-2 text-sm text-neutral-600">For partnerships, press & editorial.</div>
        </a>
        <div className="bg-white p-10">
          <MapPin className="w-6 h-6 text-[#eb5381]" />
          <div className="mt-5 text-[10px] uppercase tracking-[0.3em] text-neutral-500">Coverage</div>
          <div className="mt-2 font-serif text-2xl">Pan-India</div>
          <div className="mt-2 text-sm text-neutral-600">Mumbai · Delhi · Bangalore · Hyderabad · Pune · Chennai · Kolkata · Jaipur</div>
        </div>
      </section>

      <section>
        <SkipSearchForm variant="cream" />
      </section>
    </div>
  );
}
